import { useEffect, useState } from "react";
import type {Song} from "../api/presentations.ts";


/*Fetch default song information*/
export function useSongs(baseUrl: string) {
    const [songs, setSongs] = useState<Song[] | null>(null);
    const [_songsError, setSongsError] = useState<Error | null>(null);
    const url = `${baseUrl}/songs.json`;

    useEffect(() => {
        const ctrl = new AbortController();
        (async () => {
            try {
                const res = await fetch(url, { signal: ctrl.signal });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json: Song[] = await res.json();
                setSongs(json);
            } catch (e: any) {
                if (e.name !== "AbortError") setSongsError(e);
            }
        })();
        return () => ctrl.abort();
    }, [url]);

    return { songs};
}
